// @flow
export { default } from './LetterHead';



// WEBPACK FOOTER //
// ./src/components/letter/LetterHead/index.js